export const resources = {
  BrandAddBrandAction: '',
  KeywordAddKeyword: '',
  LabelAddLabel: '',
  KeywordRemoveTitle: '',
  KeywordsEnterKeyword: '',
  LabelsEnterLabel: '',
  BrandsEnterBrand: ''
};
